export default __webpack_public_path__ + "static/media/iconRecurHum.6f4ba92e.png";